<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Purpose</title>
<link href="../styles/9780062098979_template.css" rel="stylesheet" type="text/css"/>
<h2 class="h2b"><span>CONTENTS</span></h2>
<p class="toc" id="rded"><span><span href="#/text/9780062098979_Dedication#ded" title="Link target outside of Sample"><i>Dedication</i></span></span></p>
<p class="toc" id="rpraise"><span><span href="#/text/9780062098979_Epigraph#praise" title="Link target outside of Sample"><i>Epigraph</i></span></span></p>
<p class="toc1a" id="rfrontmatter01"><span><a href="#/text/9780062098979_Introduction#frontmatter01"><i>Introduction: The Invisible Man</i></a></span></p>
<p class="toc1" id="rchapter01"><span><a href="#/text/9780062098979_Chapter_1#chapter01"><b>1</b> - <i>The Village</i></a></span></p>
<p class="toc1" id="rchapter02"><span><span href="#/text/9780062098979_Chapter_2#chapter02" title="Link target outside of Sample"><b>2</b> - <i>Garden State Promised Land</i></span></span></p>
<p class="toc1" id="rchapter03"><span><span href="#/text/9780062098979_Chapter_3#chapter03" title="Link target outside of Sample"><b>3</b> - <i>To the Beat of My Own Drum</i></span></span></p>
<p class="toc1" id="rchapter04"><span><span href="#/text/9780062098979_Chapter_4#chapter04" title="Link target outside of Sample"><b>4</b> - <i>Three Become One</i></span></span></p>
<p class="toc1" id="rchapter05"><span><span href="#/text/9780062098979_Chapter_5#chapter05" title="Link target outside of Sample"><b>5</b> - <i>The Score</i></span></span></p>
<p class="toc1" id="rchapter06"><span><span href="#/text/9780062098979_Chapter_6#chapter06" title="Link target outside of Sample"><b>6</b> - <i>Fugees on Fire</i></span></span></p>
<p class="toc1" id="rchapter07"><span><span href="#/text/9780062098979_Chapter_7#chapter07" title="Link target outside of Sample"><b>7</b> - <i>When the Circle Broke</i></span></span></p>
<p class="toc1" id="rchapter08"><span><span href="#/text/9780062098979_Chapter_8#chapter08" title="Link target outside of Sample"><b>8</b> - <i>Wyclef for President</i></span></span></p>
<p class="toc1a" id="rbackmatter01"><span><span href="#/text/9780062098979_Conclusion#backmatter01" title="Link target outside of Sample"><i>Conclusion</i></span></span></p>
<p class="toc" id="rbackmatter02"><span><span href="#/text/9780062098979_Acknowledgments#backmatter02" title="Link target outside of Sample"><i>Acknowledgments</i></span></span></p>
<p class="toc" id="rata"><span><span href="#/text/About_the_Author#ata" title="Link target outside of Sample"><i>About the Authors</i></span></span></p>
<p class="toc" id="rphoto"><span><span href="#/text/9780062098979_Photoinsert#photo" title="Link target outside of Sample"><i>Photo Insert</i></span></span></p>
<p class="toc" id="rcredit"><span><span href="#/text/9780062098979_Credits#credit" title="Link target outside of Sample"><i>Credits</i></span></span></p>
<p class="toc" id="rcopy"><span><span href="#/text/9780062098979_Copyright#copy" title="Link target outside of Sample"><i>Copyright</i></span></span></p>
<p class="toc" id="atp_01"><span><span href="#/text/About_the_Publisher#atp01" title="Link target outside of Sample"><i>About the Publisher</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062098979_Contents.vue?6514a869